export const CaregiverPhoneType = Object.freeze({
  Home: 'Home',
  Business: 'Business',
  Mobile: 'Mobile',
});

export const CaregiverSex = Object.freeze({
  Male: 'Male',
  Female: 'Female',
  Other: 'Other',
});

export const CaregiverRelationship = Object.freeze({
  Spouse: 'Spouse',
  DomesticPartner: 'Domestic partner',
  Daughter: 'Daughter',
  Son: 'Son',
  Sibling: 'Sibling',
  OtherFamilyMember: 'Other family member',
  Friend: 'Friend',
  OtherNonFamilyMember: 'Other non-family member',
});

export const CaregiverMedicareStatus = Object.freeze({
  Yes: 'Yes',
  No: 'No',
  Declined: 'Declined',
});

export const CaregiverPreferredLanguage = Object.freeze({
  English: 'English',
  Spanish: 'Spanish',
  Mandarin: 'Mandarin',
  Other: 'Other',
});

export const TechComfortLevel = Object.freeze({
  VeryComfortable: {
    value: 'Very comfortable',
    label: 'Very comfortable',
  },
  SomewhatComfortable: {
    value: 'Somewhat comfortable',
    label: 'Somewhat comfortable',
  },
  NotVeryComfortable: {
    value: 'Not very comfortable',
    label: 'Not very comfortable',
  },
  NotComfortableAtAll: {
    value: 'Not comfortable at all',
    label: 'Not comfortable at all',
  },
});

export const CaregiverPhoneTypeOptions = Object.values(CaregiverPhoneType).map((type) => ({
  label: type,
  value: type,
}));

export const CaregiverSexOptions = Object.values(CaregiverSex).map((sex) => ({
  label: sex,
  value: sex,
}));

export const CaregiverRelationshipOptions = Object.values(CaregiverRelationship).map(
  (relationship) => ({
    label: relationship,
    value: relationship,
  }),
);

export const CaregiverMedicareStatusOptions = Object.values(CaregiverMedicareStatus).map(
  (status) => ({
    label: status,
    value: status,
  }),
);

export const CaregiverPreferredLanguageOptions = Object.values(CaregiverPreferredLanguage).map(
  (language) => ({
    label: language,
    value: language,
  }),
);

export const TechComfortLevelOptions = Object.values(TechComfortLevel);
